

document.addEventListener('DOMContentLoaded', function(){
  function isRTL() {
    if (document.querySelector('html').classList.contains('rtl_true')) return true;
    return false;
  }
  function Run(){
    // console.log(isRTL());
    // console.log("Running interval: ", interval);
    let tabby = document.querySelector('#TabbyPromo')?.querySelector('.styles__containerPortal--c9f84')?.shadowRoot?.querySelector('.styles__tabbyPromoSnippet--ed9ac.styles__tabbyPromoSnippetFontInherit--bb9df.styles__snippetWrapper--d68e9');
    let tamara = document.querySelector('tamara-widget')?.shadowRoot?.querySelector('.tamara-summary-widget__container .tamara-badge');
    if(!tabby || !tamara) return;
    clearInterval(interval);
    // console.log("Stop interval: ",interval)
    // console.log(tabby,tamara)
    // document.querySelector('.custom_payment').style.setProperty('background','red');
    tabby?.style.setProperty('position','relative');
    tabby?.querySelector('.styles__tabbyPromoSnippetContent--ef3e6')?.style.setProperty('margin','0')

    let svg = tabby.querySelector('.styles__containerPortal--c9f84');
    svg.style.setProperty('position','absolute');
    svg.style.setProperty('top','0');
    svg.style.setProperty('transform','translateY(-50%)');
  
    tamara.closest('.tamara-summary-widget__container').style.setProperty('position', 'relative');
    tamara.style.setProperty('position','absolute')
    tamara.style.setProperty('top','0')
    tamara.style.setProperty(`${isRTL() === true ? 'rigth': 'left'}`,'15px')
    tamara.style.setProperty('margin','0')
    tamara.style.setProperty('transform','translateY(-50%)');
    console.log("IS RUN FUNC")
  }
  var interval = setInterval(Run,1000);
})
